import { useSearchParams } from 'react-router-dom';

export function Connected() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const error = searchParams.get('error');

  if (error) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-worm-950">
        <div className="text-center max-w-md px-6">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-500/20 flex items-center justify-center">
            <svg className="w-8 h-8 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">Connection Failed</h1>
          <p className="text-white/70 mb-6">
            {error === 'expired' && 'This invite link has expired. Please ask for a new invitation.'}
            {error === 'invalid_state' && 'Something went wrong with the connection. Please try again.'}
            {error === 'connection_failed' && 'Failed to connect the account. Please try again.'}
            {!['expired', 'invalid_state', 'connection_failed'].includes(error) && 'An error occurred. Please try again.'}
          </p>
          <p className="text-white/50 text-sm">
            You can close this window.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-worm-950">
      <div className="text-center max-w-md px-6">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-accent-primary to-accent-secondary flex items-center justify-center">
          <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold gradient-text mb-2">Account Connected!</h1>
        <p className="text-white/70 mb-4">
          {email ? (
            <>Your Google account <span className="text-white font-medium">{email}</span> has been successfully linked.</>
          ) : (
            'Your Google account has been successfully linked.'
          )}
        </p>
        <p className="text-white/50 text-sm mb-6">
          Return to WholeWorm on your main device or browser to see your connected accounts and manage email subscriptions.
        </p>
        <p className="text-white/40 text-xs">
          You can safely close this window.
        </p>
      </div>
    </div>
  );
}
